import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService, PaymentV2Service, UtilService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-payment-sip-button',
  templateUrl: './payment-sip-button.component.html',
  styleUrls: ['./payment-sip-button.component.scss']
})
export class PaymentSipButtonComponent implements OnInit {

  @Input() config;
  @Output() btnClick = new EventEmitter();

  showDockBtn = false;

  constructor(
    public util: UtilService,
    public paymentV2: PaymentV2Service,
    public vwo: VwoService,
    public vars: VariablesService,
    public events: EventsService
  ) { }

  ngOnInit() {
  }

  redirect() {
    if(this.vwo.sip_campaign_DM_AB()) {
      const payload = {
        eventName: 'dm-campaign-select',
        info_4: this.config?.slabs_first_flow_name?.id
      };
      this.vars.event_info.info_4 = this.config?.slabs_first_flow_name?.id;
      this.events?.sendSystemEvent(payload).subscribe(_ => _);
      this.paymentV2.paymentConfig.next({slabs_first_flow: false, showSlabs: false});
    }
  }

}
